// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/appropriate-ats-unit.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/appropriate-ats-unit/appropriate-ats-unit.js';

mount([g0]);
